import { API_ROUTES } from "../configuration/RoutesApi"

export {}

declare global {
  interface String {
    truncate(maxLength: number): string
    toReadableDate(locale?: string, onlyDate?: boolean): string
    toClientRequest(): string
    toNumber(): number
    firstName(): string
    toShortTime(): string
    toSearchText(): string
    toDigitsOnly(): string
  }
}

String.prototype.toSearchText = function (): string {
  return this.toString()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .trim()
    .toUpperCase()
}

String.prototype.toDigitsOnly = function (): string {
  return this.toString().replace(/\D/g, "")
}

String.prototype.toShortTime = function (): string {
  if (!this) {
    return ""
  }

  const value = this.toString().trim()

  const match = value.match(/^(\d{2}):(\d{2})(:\d{2})?$/)

  if (!match) {
    return value
  }

  return `${match[1]}:${match[2]}`
}

String.prototype.firstName = function (): string {
  if (!this) {
    return ""
  }

  return this.trim().split(" ")[0] ?? ""
}

String.prototype.toClientRequest = function (): string {
  const rawValue = this.toString().trim()

  if (/^(https?:\/\/|data:|blob:)/i.test(rawValue)) {
    return rawValue
  }

  const cleanBase = API_ROUTES.URL_API.replace(/\/+$/, "")

  const cleanPath = rawValue.replace(/^\/+/, "")

  return `${cleanBase}/${cleanPath}`
}

String.prototype.toNumber = function (): number {
  const cleaned = this.toString()
    .replace(/[^\d.-]/g, "")
    .replace(",", ".")

  const value = parseFloat(cleaned)

  return isNaN(value) ? 0 : value
}

String.prototype.truncate = function (maxLength: number): string {
  if (this.length <= maxLength) {
    return this.toString()
  }

  return this.substring(0, maxLength) + "..."
}

String.prototype.toReadableDate = function (locale?: string, onlyDate: boolean = false): string {
  if (!this) {
    return ""
  }

  const value = this.toString()

  const date = new Date(value)

  if (isNaN(date.getTime())) {
    return value
  }

  const resolvedLocale = locale || Intl.DateTimeFormat().resolvedOptions().locale || "en-US"

  const dateFormatter = new Intl.DateTimeFormat(resolvedLocale, {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  })

  if (onlyDate) {
    return dateFormatter.format(date)
  }

  const timeFormatter = new Intl.DateTimeFormat(resolvedLocale, {
    hour: "2-digit",
    minute: "2-digit",
  })

  return `${dateFormatter.format(date)} ${timeFormatter.format(date)}`
}
